module.exports = __webpack_public_path__ + "img/g0258.b06b73a6.png";